import { ReactElement } from 'react';
import { BaseIcon, BaseIconProps } from '../BaseIcon';

export const CallIcon = ({ ...props }: Omit<BaseIconProps, 'children'>): ReactElement => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" hasLegacyStrokeStyles={true} {...props}>
    <path
      d="M14.5 8C14.8978 8 15.2794 8.15804 15.5607 8.43934C15.842 8.72064 16 9.10218 16 9.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 5C15.6935 5 16.8381 5.47411 17.682 6.31802C18.5259 7.16193 19 8.30653 19 9.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.64706 5H9.94118L11.5882 9.11765L9.52941 10.3529C10.4114 12.1413 11.8587 13.5886 13.6471 14.4706L14.8824 12.4118L19 14.0588V17.3529C19 17.7898 18.8265 18.2087 18.5176 18.5176C18.2087 18.8265 17.7898 19 17.3529 19C14.1406 18.8048 11.1107 17.4406 8.83504 15.165C6.55936 12.8893 5.19522 9.85943 5 6.64706C5 6.21023 5.17353 5.7913 5.48241 5.48241C5.7913 5.17353 6.21023 5 6.64706 5"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </BaseIcon>
);

CallIcon.displayName = 'CallIcon';
